document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.Product_object_ingredients_slider').forEach(function (el) {
        new Swiper(el, {
            slidesPerView: 4, 
            spaceBetween: 16,
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.2
                },
                750: {
                    slidesPerView: 2
                },
                990: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            }
        });
    });
});